import React from 'react'
import Layout from '../../layout'

import { PageHeader } from '../../components/typography/PageHeader'
import AllLogs from './AllLogs'

const AuditLogs: React.FC = () => {
  return (
    <Layout>
      <PageHeader title="Audit Logs" />

      <AllLogs />
    </Layout>
  )
}

export default AuditLogs
